import { LabelValuePairsType } from 'core/types/common';

export const DATA_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Related Order ID',
    value: 'orderId',
    searchKeys: ['order.orderNumber'],
  },
  {
    label: 'Transfer ID',
    value: 'id',
    searchKeys: ['toId'],
  },
  {
    label: 'TO number',
    value: 'transferNumber',
    searchKeys: ['transferNumber'],
  },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['items.variantSku'],
  },
];
